import React from 'react';
import { Quote } from 'lucide-react';
import testimonial1 from '../assets/testimonial_1.png';
import testimonial2 from '../assets/testimonial_2.png';
import testimonial3 from '../assets/testimonial_3.png';

const testimonials = [
    {
        quote: "AutomateIt.ng saved our support team 20+ hours weekly. The WhatsApp bot handles 80% of inquiries automatically.",
        author: "Tunde A.",
        role: "COO, Logistics Co.",
        image: testimonial1,
    },
    {
        quote: "The n8n workflows they built replaced two manual staff roles, allowing us to reassign those funds to marketing.",
        author: "Sarah K.",
        role: "Founder, E-commerce Brand",
        image: testimonial2,
    },
    {
        quote: "Professional, fast, and incredibly knowledgeable. They understood our complex requirements immediately.",
        author: "David O.",
        role: "Operations Manager",
        image: testimonial3,
    },
];

const Testimonials: React.FC = () => {
    return (
        <section id="testimonials" className="py-24 bg-navy-800">
            <div className="max-w-7xl mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
                    Trusted by Ambitious Businesses
                </h2>

                <div className="grid md:grid-cols-3 gap-8">
                    {testimonials.map((item, index) => (
                        <div key={index} className="p-8 rounded-2xl bg-navy-900 border border-white/[0.05] relative">
                            <Quote className="w-8 h-8 text-brand-cyan/20 mb-6" />
                            <p className="text-text-muted mb-6 text-lg leading-relaxed">
                                "{item.quote}"
                            </p>
                            <div className="flex items-center gap-3">
                                <img
                                    src={item.image}
                                    alt={item.author}
                                    className="w-12 h-12 rounded-full object-cover border-2 border-white/10"
                                />
                                <div>
                                    <div className="text-white font-semibold">{item.author}</div>
                                    <div className="text-xs text-text-muted">{item.role}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
